module.exports = __webpack_public_path__ + "static/media/certified.7bb4615c.png";